import React, { useRef } from 'react';
import { useIsOverflow } from '../../../../../../infrastructure/hooks/useIsOverflow';

import { IScrollProps, ScrollStyle } from './styles';

const Scroll: React.FC<IScrollProps> = (props) => {
  const ref = useRef<HTMLDivElement>(null);
  const overflowing = useIsOverflow(ref);

  return (
    <ScrollStyle {...props} overflowing={overflowing} ref={ref}>
      {props.children}
    </ScrollStyle>
  );
};

export { Scroll };
